import { render, staticRenderFns } from "./SignatureCompleteStatus.vue?vue&type=template&id=2bf2d48e"
import script from "./SignatureCompleteStatus.vue?vue&type=script&lang=js"
export * from "./SignatureCompleteStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports